import { call, put, takeLatest } from 'redux-saga/effects';
import { notificationApi } from '../../../api';
import {
    GET_UNREAD_NOTIFICATIONS_REQUEST,
    getUnreadNotificationsSuccess,
    getUnreadNotificationsFail,
    GET_RECENT_NOTIFICATIONS_REQUEST,
    getRecentNotificationsSuccess,
    getRecentNotificationsFail,
    GET_UNREAD_COUNT_REQUEST,
    getUnreadCountSuccess,
    getUnreadCountFail,
    MARK_NOTIFICATION_AS_READ_REQUEST,
    markNotificationAsReadSuccess,
    markNotificationAsReadFail,
    MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST,
    markAllNotificationsAsReadSuccess,
    markAllNotificationsAsReadFail
} from '../actions/notificationActions';

export function* getUnreadNotificationsSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        const resp = yield call(notificationApi.getUnread, { 
            userId: action.payload.userId, 
            roleId: action.payload.roleId,
            token 
        });
        yield put(getUnreadNotificationsSuccess(resp.data));
    } catch (error) {
        yield put(getUnreadNotificationsFail(error.message));
    }
}

export function* getRecentNotificationsSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        const resp = yield call(notificationApi.getRecent, { 
            userId: action.payload.userId, 
            roleId: action.payload.roleId,
            token 
        });
        const notifications = resp.data.content || resp.data;
        yield put(getRecentNotificationsSuccess(notifications));
    } catch (error) {
        yield put(getRecentNotificationsFail(error.message));
    }
}

export function* getUnreadCountSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        const resp = yield call(notificationApi.getCount, { 
            userId: action.payload.userId, 
            roleId: action.payload.roleId,
            token 
        });
        yield put(getUnreadCountSuccess(resp.data));
    } catch (error) {
        yield put(getUnreadCountFail(error.message));
    }
}

export function* markNotificationAsReadSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        yield call(notificationApi.markRead, { id: action.payload.id, token });
        yield put(markNotificationAsReadSuccess(action.payload.id));
    } catch (error) {
        yield put(markNotificationAsReadFail(error.message));
    }
}

export function* markAllNotificationsAsReadSaga(action) {
    const token = sessionStorage.getItem('token');
    try {
        yield call(notificationApi.markAllRead, { userId: action.payload.userId, token });
        yield put(markAllNotificationsAsReadSuccess());
    } catch (error) {
        yield put(markAllNotificationsAsReadFail(error.message));
    }
}

export default function* watchNotificationSagas() {
    yield takeLatest(GET_UNREAD_NOTIFICATIONS_REQUEST, getUnreadNotificationsSaga);
    yield takeLatest(GET_RECENT_NOTIFICATIONS_REQUEST, getRecentNotificationsSaga);
    yield takeLatest(GET_UNREAD_COUNT_REQUEST, getUnreadCountSaga);
    yield takeLatest(MARK_NOTIFICATION_AS_READ_REQUEST, markNotificationAsReadSaga);
    yield takeLatest(MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST, markAllNotificationsAsReadSaga);
}
